import { Avatar, Paper } from "@mui/material";
import Link from "next/link";
import React from "react";
import { Col, Row } from "react-bootstrap";
import * as constants from "../../../Components/constants";
import SignUpModal from "../../ModalContent/SignUpModal/SignUpModal";

const BASE_URL = constants.BASE_URL;

const GroupMember = ({ groupID, isLoggedIn }) => {
  const [members, setMembers] = React.useState([]);

  //sign up modal
  const [openSingUp, setOpenSignUp] = React.useState(false);
  const handleSignUpClose = () => {
    setOpenSignUp(false);
  };

  const handleSignUpOpen = () => {
    setOpenSignUp(true);
  };

  React.useEffect(() => {
    fetch(`${BASE_URL}/group/${groupID}/members/`, {
      method: "GET",
      headers: {
        // Authorization: `Token ${localStorage.getItem("auth_token")}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setMembers(data);
      });
  }, [groupID]);
  return (
    <>
      <Row xs={1} md={4} className="my-1 g-2">
        {members.map((member, idx) => (
          <Col key={idx}>
            <Paper
              elevation={0}
              className="p-2 rounded-3"
              style={{ height: "9rem", cursor: "pointer" }}
            >
              <div className="d-flex flex-column align-items-center">
                {isLoggedIn ? (
                  <Link key={idx} href={`/user/${member.id}`}>
                    <Avatar
                      sx={{
                        width: 60,
                        height: 60,
                        border: 1,
                        borderColor: "grey.500",
                      }}
                      alt="alt"
                      src={member.profile_pic}
                    />
                  </Link>
                ) : (
                  <Avatar
                    onClick={() => handleSignUpOpen()}
                    sx={{
                      width: 60,
                      height: 60,
                      border: 1,
                      borderColor: "grey.500",
                    }}
                    alt="alt"
                    src={member.profile_pic}
                  />
                )}

                <div className="text-center">
                  {isLoggedIn ? (
                    <Link key={idx} href={`/user/${member.id}`}>
                      <small>
                        <b>{member.first_name}</b>
                      </small>
                    </Link>
                  ) : (
                    <small onClick={() => handleSignUpOpen()}>
                      <b>{member.first_name}</b>
                    </small>
                  )}
                  <span className="d-block">{member.academic_discipline}</span>
                  <span>{member.profession} </span>
                </div>
              </div>
            </Paper>
          </Col>
        ))}
      </Row>
      <>
        <SignUpModal
          open={openSingUp}
          handleClose={handleSignUpClose}
          handleOpen={handleSignUpOpen}
        />
      </>
    </>
  );
};

export default GroupMember;
